export default "__VITE_ASSET__fD_UHXmC__"